var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuVouchersInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-366.000000, -314.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(366.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Vouchers_Inactive",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4 C13.553,4 14,4.447 14,5 L14,15 C14,15.5530005 13.553,16 13,16 L1,16 C0.447,16 0,15.5530005 0,15 L0,5 C0,4.447 0.447,4 1,4 L2.184,4 C2.072,3.686 2,3.353 2,3 C2,1.343 3.343,0 5,0 C5.771,0 6.469,0.3 7,0.778 C7.531,0.3 8.229,0 9,0 C10.657,0 12,1.343 12,3 C12,3.353 11.928,3.686 11.816,4 L13,4 Z M6,4 L6,3 C6,2.447 5.553,2 5,2 C4.447,2 4,2.447 4,3 C4,3.553 4.447,4 5,4 L6,4 Z M8,3 L8,4 L9,4 C9.553,4 10,3.553 10,3 C10,2.447 9.553,2 9,2 C8.447,2 8,2.447 8,3 Z M6,14 L6,6 L2,6 L2,14 L6,14 Z M12,14 L12,6 L8,6 L8,14 L12,14 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuVouchersInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Vouchers_Inactive.9764c4c256d656efa5c87b8749b30029.svg";
export { ForwardRef as ReactComponent };